/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  TableContainer,
  Table,
  TableCell,
  TableRow,
  TableBody,
  Paper,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  formatDateWithYear,
  levelToCEFR,
  typeOfLanguageFormatting,
  typeOfTrainingFormatting,
} from '../../../helpers/utils';

const useStyles = makeStyles({
  root: {
    marginTop: '30px',
    marginBottom: '30px',
  },
});

const CourseInformations = ({ courseInfos }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const companyName = courseInfos?.company?.name ?? '';
  const level = courseInfos?.level ? levelToCEFR(courseInfos.level) : '';
  const courseName = courseInfos?.name ?? '';

  const typeOfLanguage = courseInfos?.coursePlan?.typeoflanguage
    ? typeOfLanguageFormatting(courseInfos.coursePlan.typeoflanguage)
    : t('common.na', 'n/a');

  const trainingTypesArr = Array.isArray(courseInfos?.coursePlan?.typeoftraining)
    ? courseInfos.coursePlan.typeoftraining
    : [];

  const trainingTypesText = trainingTypesArr.length > 0
    ? trainingTypesArr.map((item) => typeOfTrainingFormatting(item)).join(', ')
    : t('common.na', 'n/a');

  const duration = courseInfos?.coursePlan?.duration ?? 0;
  const beginDate = courseInfos?.coursePlan?.beginDate
    ? formatDateWithYear(courseInfos.coursePlan.beginDate)
    : '';

  const endDate = courseInfos?.coursePlan?.endDate
    ? formatDateWithYear(courseInfos.coursePlan.endDate)
    : '';

  const teachersArr = Array.isArray(courseInfos?.idTeachers) ? courseInfos.idTeachers : [];
  const teachersText = teachersArr.length > 0
    ? teachersArr.map((teacher) => `${teacher.name} ${teacher.firstname}`).join(', ')
    : t('courseInformations.noTeachers', 'No teachers');

  return (
    <TableContainer component={Paper} className={classes.root}>
      <Table sx={{ minWidth: 650 }} aria-label={t('courseInformations.tableAria', 'course informations table')}>
        <TableBody>
          <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell align="left" variant="head">
              {t('courseInformations.labels.company', 'Société')}
            </TableCell>
            <TableCell align="left">{companyName}</TableCell>
          </TableRow>

          <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell align="left" variant="head">
              {t('courseInformations.labels.level', 'Niveau')}
            </TableCell>
            <TableCell align="left">{level}</TableCell>
          </TableRow>

          <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell align="left" variant="head">
              {t('courseInformations.labels.trainingTitle', 'Intitulé de la formation')}
            </TableCell>
            <TableCell align="left">{courseName}</TableCell>
          </TableRow>

          <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell align="left" variant="head">
              {t('courseInformations.labels.trainingDetails', 'Détails de la formation')}
            </TableCell>
            <TableCell align="left">
              {t('courseInformations.labels.languageType', 'Type de langage:')}
              {' '}
              {typeOfLanguage}
              <br />
              {t('courseInformations.labels.trainingType', "Type d'entraînement:")}
              {' '}
              {trainingTypesText}
            </TableCell>
          </TableRow>

          <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell align="left" variant="head">
              {t('courseInformations.labels.duration', 'Durée')}
            </TableCell>
            <TableCell align="left">
              {duration}
              {t('common.hourShort', 'h')}
            </TableCell>
          </TableRow>

          <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell align="left" variant="head">
              {t('courseInformations.labels.beginDate', 'Date de début')}
            </TableCell>
            <TableCell align="left">{beginDate}</TableCell>
          </TableRow>

          <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell align="left" variant="head">
              {t('courseInformations.labels.endDate', 'Date de fin')}
            </TableCell>
            <TableCell align="left">{endDate}</TableCell>
          </TableRow>

          <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell align="left" variant="head">
              {t('courseInformations.labels.teachers', 'Formateur')}
            </TableCell>
            <TableCell align="left">{teachersText}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CourseInformations;
